var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolve = resolve;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _reactNative = require("react-native");

function resolve(styleProp, cleanedProps) {
  if (styleProp) {
    return _reactNative.StyleSheet ? [styleProp, cleanedProps] : styleProp[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"] ? Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(styleProp), [cleanedProps])) : (0, _extends2.default)({}, styleProp, cleanedProps);
  } else {
    return cleanedProps;
  }
}